import {useState} from "react";
import classes from "../../../components/adminEdit/AdminEdit.module.scss";
import AdminEdit from "../../../components/adminEdit/AdminEdit";
import {Link, useNavigate} from "react-router-dom";
import AdminQuizService from "../../../services/AdminQuizService";

function AdminQuizes(){
	const navigate = useNavigate();
	const [items, setItems] = useState([]);

	function TableHeaders(){
		return(<div className={classes.th}>
			<div className={classes.td}></div>
			<div className={classes.td}>Tittel</div>
			<div className={classes.td}>Vis</div>
			<div className={classes.td}>Innsendinger</div>
		</div>)
	}

	function UnEditableSectionChildren({obj, refObj}){
		return(<>
			<div className={classes.td}>
				<Link to={'/quiz/'+obj._id}>vis</Link>
			</div>
			<div className={classes.td}>
				<Link to={'/admin/quizer/'+obj._id+'/innsendinger'}>Innsendinger</Link>
			</div>
		</>)
	}


	function EditableSectionChildren({obj, index, handleChange}) {return(<>

	</>)}

	function BeforeTableChildren(){return(
		<Link to={'/admin/quizer/ny'}>
			<button className={'button1'}>Ny quiz</button>
		</Link>
	)}

	const sendToEditPage =(obj)=>{
		navigate(`/admin/quizer/${obj._id}`)
	}

	return(
		<AdminEdit
			/*PaginationBool={true}
			SortObject={{editedDate:'Redigerings-dato', date:'Dato', active:'Aktiv', pluss:'Pluss', author:'Forfatter', urlString:'URL', viewCount:'Visninger'}}
			SearchObject={{urlString:'URL'}}
			DefaultSearch={'editedDate'}
			DefaultSortOrder={'-1'}*/
			editIconActionOverride={sendToEditPage}
			pageName={"Quizer"}
			mainService={AdminQuizService}
			mainArray={items}
			setMainArray={setItems}
			TableHeaders={TableHeaders}
			EditableSectionChildren={EditableSectionChildren}
			UnEditableSectionChildren={UnEditableSectionChildren}
			BeforeTableChildren={BeforeTableChildren}
		></AdminEdit>
	)
}

export default AdminQuizes;